module.exports = __webpack_public_path__ + "static/media/stock-tv.d3968f17.jpg";